import { Github, Linkedin, Twitter, Instagram } from 'lucide-react';
import { LOGOS } from '@/i18n';

const Footer = ({ lang, t }) => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/10 bg-[rgb(var(--bg-0))]" data-testid="site-footer">
      <div className="section-divider" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            {/* Footer logo: square isologo only (no text) */}
            <a href="#top" aria-label="Cauratech" data-testid="footer-logo">
              <img
                src={LOGOS.isologo_dark_bg}
                alt="Cauratech"
                className="h-12 w-12 rounded-xl"
              />
            </a>
            <p className="mt-4 text-sm text-white/65 max-w-sm leading-relaxed">{t.footer.description}</p>
            <div className="mt-5 flex items-center gap-2" data-testid="footer-socials">
              {[
                { Icon: Github, label: 'GitHub' },
                { Icon: Linkedin, label: 'LinkedIn' },
                { Icon: Twitter, label: 'Twitter' },
                { Icon: Instagram, label: 'Instagram' },
              ].map(({ Icon, label }) => (
                <a key={label} href="#" aria-label={label} className="h-9 w-9 grid place-items-center rounded-full border border-white/10 text-white/70 hover:text-white hover:border-[rgba(5,126,243,.5)] hover:bg-[rgba(5,126,243,.08)] transition-colors">
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="kicker-mono text-white/60">{t.footer.columns.product}</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#services" className="text-white/75 hover:text-white">{lang === 'es' ? 'Plataformas' : 'Platforms'}</a></li>
              <li><a href="#services" className="text-white/75 hover:text-white">{lang === 'es' ? 'IA & Automatización' : 'AI & Automation'}</a></li>
              <li><a href="#services" className="text-white/75 hover:text-white">{lang === 'es' ? 'Seguridad Gov-Grade' : 'Gov-Grade Security'}</a></li>
              <li><a href="#services" className="text-white/75 hover:text-white">Blockchain & Web3</a></li>
              <li><a href="#services" className="text-white/75 hover:text-white">{lang === 'es' ? 'Soluciones Bancarias' : 'Banking Solutions'}</a></li>
              <li><a href="#services" className="text-white/75 hover:text-white">Cauracademy</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="kicker-mono text-white/60">{t.footer.columns.company}</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#credentials" className="text-white/75 hover:text-white">{t.nav.credentials}</a></li>
              <li><a href="#about" className="text-white/75 hover:text-white">{t.nav.about}</a></li>
              <li><a href="#blog" className="text-white/75 hover:text-white">{t.nav.blog}</a></li>
              <li><a href="#contact" className="text-white/75 hover:text-white">{t.nav.contact}</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="kicker-mono text-white/60">{t.footer.columns.resources}</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#tech" className="text-white/75 hover:text-white">{t.nav.tech}</a></li>
              <li><a href="#" className="text-white/75 hover:text-white">{lang === 'es' ? 'Política de privacidad' : 'Privacy policy'}</a></li>
              <li><a href="#" className="text-white/75 hover:text-white">{lang === 'es' ? 'Términos' : 'Terms'}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row gap-3 items-center justify-between text-xs text-white/50">
          <div>© {year} Cauratech. {t.footer.rights}</div>
          <div className="kicker-mono">{lang === 'es' ? 'Tu identidad secreta tecnológica' : 'Your secret tech identity'} · v1.2</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
